import { render, staticRenderFns } from "./MergedDealersList.vue?vue&type=template&id=38a05b48&scoped=true"
import script from "./MergedDealersList.vue?vue&type=script&lang=js"
export * from "./MergedDealersList.vue?vue&type=script&lang=js"
import style0 from "./MergedDealersList.vue?vue&type=style&index=0&id=38a05b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a05b48",
  null
  
)

export default component.exports